// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M20.9999 5.65341L11.9983 0.450195L2.99917 5.65195L11.9984 10.8458L20.9999 5.65341Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M21.9983 7.38641L12.9983 12.5779V22.9725L21.9983 17.7705V7.38641Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10.9983 22.9655V12.5778L1.99829 7.3835V17.7005L10.9983 22.9655Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-control-platform-filled')
export default class ControlPlatformFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'control-platform-filled',
    }
  }
}
